<template>
	
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>人物管理 > <b>真人声音复刻列表</b></BreadcrumbItem>
      </Breadcrumb>
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
			<span class="search_span_width">
			 <span class="search_span_width_part1">克隆方式：</span>
					<Select v-model="search.voice_source"  style="width:130px">
					  <Option value="0">请选择</Option>
					  <Option value="cosyvoice" :key="cosyvoice">CosyVoice</Option>
					  <Option value="hs" :key="hs">HS</Option>
					  <Option value="minimax" :key="minimax">MiniMax</Option>
					</Select>
			</span>
			<span class="search_span_width">
			 <span class="search_span_width_part1">克隆状态：</span>
					<Select v-model="search.status"  style="width:100px">
					  <Option value="0">请选择</Option>
					  <Option value="SUCCESS" :key="SUCCESS">成功</Option>
					  <Option value="FAIL" :key="FAIL">失败</Option>
					</Select>
			</span>
			<span class="search_span_width">
	         <span class="search_span_width_part1">音色：</span>
	       				 <Input v-model="search.model_id" style="width: 130px" clearable/>
	       	</span>
			   <span class="search_span_width">
	         <span class="search_span_width_part1">音色名称：</span>
	       				 <Input v-model="search.voice_name" style="width: 130px" clearable/>
	       	</span>
        <span class="search_span_width">
				<span class="search_span_width_part1">客户：</span>
				<Select style="width:200px"
                clearable
                v-model="search.user_id"
                filterable
                :remote-method="userlist"
                :loading="loading2">
					 <Option v-for="(option, index) in user_list" :value="option.id" :key="index">{{option.mobile}}</Option>
				</Select>
			</span>
	    </span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getVoiceList()">搜索</Button>
      </Card>
      <p :style="{'margin':'5px 10px 10px 20px','clear':'both','overflow':'hidden'}">
			<span :style="{'text-align':'center','float':'left'}">
				<Button type='primary' :style="{'margin-left':'5px'}" @click="addVoiceModal()">音色复刻</Button>
			</span>
      </p>
      <Card>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="voice_list"></Table>
		  <Page :total="recordTotal" :current="page" :page-size="20" :show-elevator="true" @on-change="getVoiceList"/>
        </Card>
      </Card>
    </Content>
    <Modal v-model="showinfomodal" :footer-hide=true title="编辑">
      <Form ref="voice_train" :model="voice_train" :label-width="80" >
        <FormItem label="ID" prop="id">
          <Input v-model="voice_train.id"  disabled/>
        </FormItem>
        <FormItem label="名称" prop="voice_name">
          <Input v-model="voice_train.voice_name"  />
        </FormItem>
        <FormItem label="音色" prop="model_id">
          <Input v-model="voice_train.model_id" />
        </FormItem>
        <FormItem label="性别" prop="gender">
          <RadioGroup v-model="voice_train.gender">
            <Radio label="male">男</Radio>
            <Radio label="female">女</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="updateVoiceTrain()">提交</Button>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="showmodal" :footer-hide=true title="音色复刻">
      <Form ref="voice" :model="voice" :label-width="80" :rules="voiceRule" >
		<FormItem label="复刻方式" prop="voice_source">
		  <RadioGroup v-model="voice.voice_source">
		    <Radio label="hs">HS</Radio>
		    <Radio label="minimax">MiniMax</Radio>
			<Radio label="cosyvoice">cosyvoice</Radio>
		  </RadioGroup>
		</FormItem>
		<FormItem label="音色版本" prop="model_type" v-show="voice.voice_source=='hs'">           
			<Select v-model="voice.model_type"  style="width:130px">
				<Option :value='4'>ICL2.0</Option>
				<Option :value='3'>DiT</Option>
				<Option :value='0'>ICL1.0</Option>   
			</Select>
		</FormItem>  			
        <FormItem label="音色名称" prop="voice_name">
          <Input placeholder="上传文件自动取文件名"  v-model="voice.voice_name"/>
        </FormItem>
		<FormItem label="性质" prop="private_user">
		  <RadioGroup v-model="voice.private_user" @on-change="change_private">
		    <Radio label="1">公共</Radio>
		    <Radio label="2">客户独享(归属人为填写客户)</Radio>
			<Radio label="3">私有(无具体归属，填写客户为使用者或训练人)</Radio>
		  </RadioGroup>
		</FormItem>
        <FormItem label="客户信息" prop="user_id" v-show="this.voice.private_user != '1'">
          <Select
                  clearable
                  v-model="voice.user_id"
                  filterable
                  :remote-method="userlist"
                  :loading="loading2">
             <Option v-for="(option, index) in user_list" :value="option.id" :key="index">{{option.mobile}}</Option>
          </Select>
        </FormItem>
        <FormItem label="性别" prop="gender">
          <RadioGroup v-model="voice.gender">
            <Radio label="male">男</Radio>
            <Radio label="female">女</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="音频地址" prop="voice_url">
          <audio ref="audio" controls="controls" width='100%' height="100%"></audio>
          <Upload :action="getUploadUrl" :headers="uploadHeader" :on-success="successUpload">
            <Button icon="ios-cloud-upload-outline">上传音频</Button>
          </Upload>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="megaTtsAudioUpload()" v-text="train_button"></Button>
        </FormItem>
      </Form>
    </Modal>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
		train_button:'提交',
		search : {
			model_id:'',
			voice_name:'',
			user_id:"",
			is_confirm:0,
			is_open:'',
			voice_source:'',
			status:''
		},
		page: 1,
		loading2: false,
		recordTotal:0,
		showmodal:false,
		showinfomodal:false,
		voice:{
		  id:0,
		  voice_name:"",
		  gender:"male",
		  voice_url:'',
		  user_id:0,
		  voice_source:'hs',
		  model_type:4,
		  private_user:'2'
		},
		voiceRule :{
		  voice_name:[
			{ required: true, message: "请输入音色名称", trigger: "blur" },
		  ]
		},
		voice_train:{
		  id:0,
		  user_id:'',
		  voice_source:"",
		  voice_name:'',
		  demo_voice_url:'',
		  model_id:'',
		  gender:'',
		  is_confirm:'0',
		  is_demo:'0',
		  is_open:'0',
		  scenario:"",
		  status:"",
		  message:""
		},
	voice_list:[],
    user_list:[],
	tableColumns:[
		  { title: 'ID', key: 'id', align: 'center',width:'80px' },
		  { title: '音色编号', key: 'model_id', align: 'center' },
		  { title: '声音ID', key: 'spk_id', align: 'center' },
		  { title: '来源', key: 'voice_source', align: 'center',
			   render: (h, params) => {
				 var txt = params.row.voice_source;
				 if (params.row.voice_source =='hs') {
					txt += '-'+(params.row.model_type == '0' ? 'v1' : 'v2');
				 }
				 return h("div",{},txt);
			   }
		   },
		  { title: '音色名称', key: 'voice_name', align: 'center',width:'150px' },
		  //{ title: '声音复刻次数', key: 'voice_clone_num', align: 'center' },
		  { title: '性别', key: 'gender', align: 'center',width:'80px',
			render: (h, params) => {
			  var txt = '';
			  if (params.row.gender =='female') {
				txt = '女';
			  } else{
				txt = '男';
			  }

			  return h("div",{},txt);
			}
		  },
		  { title: '发音模板', key: 'is_demo', align: 'center',
			render: (h, params) => {
			  var txt = '';
			  if (params.row.is_demo =='1') {
				txt = '已生成';
			  }else{
				txt = '未生成';
			  }
			  return h("div",{},txt);
			}
		  },
		  { title: '复刻状态', key: 'status', align: 'center' },
		  { title: '创建时间', key: 'created_at', align: 'center',width:'150px' },
		  { title: 'demo', key: 'demo_voice_url',
			render:(h,params) =>{
			   return h('span',{
			   domProps: {
				  innerHTML: '<audio controls="controls" style="width:100px;height:25px;"><source src="'+(params.row.zh_voice_url ? params.row.zh_voice_url :params.row.demo_voice_url)+'" type="audio/mpeg" /></audio>'
			  }
			   })
			}
		   },
    { title: '训练音频', key: 'zh_voice_url',
      render:(h,params) =>{

        const j = JSON.parse(params.row.voice_urls);
        let audioUrl = ""
        if(j && j.audio_record_url){
          audioUrl = j.audio_record_url
        } else if (j && j.audio_url) {
			audioUrl = j.audio_url;
		}

        console.log("音频", audioUrl)
        return h('span',{
          domProps: {
            innerHTML: '<audio controls="controls" style="width:100px;height:25px;"><source src="'+audioUrl+'" type="audio/mpeg" /></audio>'
          }
        })
      }
    },
		  { title: '操作', key: 'action', align: 'center',width: 200,
			render: (h, params) => {
			  let btns=[]
				btns.push(
					h('Button', {
					  props: { type: 'warning', size: 'small' },
					  style: { marginRight: '5px', marginBottom: '5px'},
					  on: {
						click: () => {
						  this.voice_train.id = params.row.id;
						  this.voice_train.user_id = params.row.user_id;
						  this.voice_train.voice_source = params.row.voice_source;
						  this.voice_train.voice_name = params.row.voice_name;
						  this.voice_train.demo_voice_url =params.row.demo_voice_url;
						  this.voice_train.model_id =params.row.model_id;
						  this.voice_train.gender =params.row.gender;
						  this.voice_train.is_confirm =params.row.is_confirm.toString();
						  this.voice_train.is_demo =params.row.is_demo.toString();
						  this.voice_train.is_open =params.row.is_open.toString();
						  this.showinfomodal = true;
						}
					  }
					}, '编辑')
				);
				//minimax重新复刻
				if (params.row.voice_source == 'minimax' && params.row.spk_id ==0) {
					btns.push(
						h('Button', {
						  props: { type: 'primary', size: 'small' },
						  style: { marginRight: '5px', marginBottom: '5px'},
						  on: {
							click: () => {
							  this.voice.id = params.row.id;
							  this.voice.voice_name = params.row.voice_name;
							  this.voice.user_id = params.row.user_id;
							  this.voice.voice_source = params.row.voice_source;
							  this.voice.private_user = params.row.private_type.toString();
							  this.voice.voice_url = '';
							  this.train_button = '提交';
							  this.showmodal = true;
							}
						  }
						}, '重新复刻')
					);
					if (params.row.status == 'SUCCESS') {
						btns.push(
							h('Button', {
							  props: { type: 'info', size: 'small' },
							  style: { marginRight: '5px', marginBottom: '5px'},
							  on: {
								click: () => {
								  this.minimaxshelf(params.row.id);
								}
							  }
							}, '启用')
						);
					}
					
				}
				if (params.row.voice_source == 'cosyvoice') {
					btns.push(
						h('Button', {
						  props: { type: 'info', size: 'small' },
						  style: { marginRight: '5px', marginBottom: '5px'},
						  on: {
							click: () => {
							  this.delVoice(params.row.id);
							}
						  }
						}, '删除')
					);
				}
				return h("div",btns);
			}
		}
	],
    uploadHeader:{
      "Authorization":localStorage.getItem('token')
    },
	}
  },
  mounted:function(){
    this.getVoiceList();
  },
  computed:{
    getUploadUrl(){
      return process.env.VUE_APP_ADMINHOST+'/voice/uploadvoicefile';
    }
  },
  methods:{
	change_private(private_user){
		if (private_user == 1) {
			this.voice.user_id = 0;
		}
	},
	addVoiceModal(){
		this.voice.id = 0;
		this.voice.voice_name = '';
		this.voice.voice_url = '';
		this.showmodal = true;
	},
	getVoiceList(page=this.page) {
		this.page = page;
		let p = {'page' : page}
		let params = Object.assign(this.search, p);
		this.http1.get('/voice/voice_train_list',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.voice_list = data.res.list;
			this.recordTotal = data.res.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
    userlist(query){
      if (query !== '' && query.length==11) {
        this.loading2 = true;
        setTimeout(() => {
          this.loading2 = false;

          this.http.get('/admin/user/userList',{params:{mobile:query}}).then(response=>{
            let data=response.data;
            if(data.code!==0)
            {
              alert(data.message);
            } else{
              this.user_list = data.data.list;
            }
          }).catch(()=>{
            this.$Message.error('网络错误');
          });

        }, 200);
      }
    },
	delVoice(train_id){
		this.$Modal.confirm({
		  content: '<p>确定删除？</p>',
		  onOk: () => {
		    this.http1.post('/voice/delVoice',{train_id:train_id}
		    ).then(response=>{
		      let data=response.data;
		      if(data.code!==0) {
		        this.$Message.error(data.message);
		        return false;
		      }else{
		        this.$Message.info(data.message);
		        this.showinfomodal =false;
		        this.getVoiceList(this.page);
		        return true;
		      }
		    });
		  }
		});
	},
	minimaxshelf(train_id){
		this.$Modal.confirm({
		  content: '<p>确定提交？</p>',
		  onOk: () => {
		    this.http1.post('/voice/shelfMinimax',{train_id:train_id}
		    ).then(response=>{
		      let data=response.data;
		      if(data.code!==0) {
		        this.$Message.error(data.message);
		        return false;
		      }else{
		        this.$Message.info(data.message);
		        this.showinfomodal =false;
		        this.getVoiceList(this.page);
		        return true;
		      }
		    });
		  }
		});
	},
    updateVoiceTrain(){
      this.$Modal.confirm({
        content: '<p>确定提交？</p>',
        onOk: () => {
          this.http1.post('/voice/updateVoiceTrain',this.voice_train
          ).then(response=>{
            let data=response.data;
            if(data.code!==0) {
              this.$Message.error(data.message);
			  this.showinfomodal =false;
			  this.getVoiceList(this.page);
              return false;
            }else{
              this.$Message.info(data.message);
              this.showinfomodal =false;
              this.getVoiceList(this.page);
              return true;
            }
          });
        }
      });
    },
    megaTtsAudioUpload(){
      this.$Modal.confirm({
        content: '<p>确定提交？</p>',
        onOk: () => {
			this.train_button = '训练中,请等待结果...';
          this.http1.post('/voice/megaTtsAudioUpload',this.voice
          ).then(response=>{
            let data=response.data;
            if(data.code!==0) {
              this.$Message.error(data.message);
              return false;
            }else{
              this.$Message.info(data.message);
              this.showmodal =false;
              this.getVoiceList(this.page);
              return true;
            }
          });
        }
      });

    },
    successUpload(response, file, fileList){
      this.voice.voice_name = file.name;
      let data=response
      if(data.code!=0) {
        this.$Message.error(data.message);
        return true;
      }
     // alert(data.data.path);
      this.voice.voice_url=data.data.full_path;
      this.$refs.audio.src = data.data.full_path+"?ran=" + Math.random();
    },
  }

}
</script>
